import { loadable } from 'nordic/lazy';

const AndesMessageIntervention = loadable(async () =>
  import(/* webpackChunkName: "chunk-andes-message-intervention" */ './MessageIntervention'),
);

export default AndesMessageIntervention;
